(function(){
    'use strict';
    angular.module('quantixApp').factory('keycloakAuthInterceptor', function ($q, AuthKeycloak) {
        return {
            request: function (config) {
                var deferred = $q.defer();
                if (AuthKeycloak.authz.token) {
                    AuthKeycloak.authz.updateToken(5).success(function () {
                        config.headers = config.headers || {};
                        config.headers.Authorization = 'Bearer ' + AuthKeycloak.authz.token;

                        deferred.resolve(config);
                    }).error(function () {
                        deferred.reject('Failed to refresh token');
                    });

                    // AuthKeycloak.authz.loadUserInfo().success(function () {
                    // 	console.log("sadas");
                    // }).error(function () {
                    // 	console.log("error");
                    // });
                }
                return deferred.promise;
            },

            'responseError': function(rejection) {
                // do something on error
                if(rejection.status===401){
                    AuthKeycloak.authz.logout({'redirectUri':AuthKeycloak.logoutUrl});
                }
               return $q.reject(rejection);
            }

        };
    });

})();